import { Badge } from '../ui/badge';

type TagsListProps = {
  tagsList: string;
};

const toList = (tagsString: string): string[] => {
  return tagsString
    .split(',')
    .map(tag => tag.trim())
    .filter(tag => tag.length > 0);
};

export const TagsList = ({ tagsList }: TagsListProps) => {
  return (
    <div className='flex flex-wrap gap-2'>
      {toList(tagsList).map((tag, index) => (
        <Badge key={index} variant='outline' className='text-xs'>
          {tag}
        </Badge>
      ))}
    </div>
  );
};
